export default "__VITE_ASSET__7FYSDECU__"